import { cn } from "../cn";

/**
 * The rail's shape: full height and edge to edge on a narrow screen, a
 * floating 216px glass panel beside the strip on a wide one, 64px collapsed.
 */
export function workspaceRailClass(collapsed = false): string {
  return cn(
    "flex h-dvh w-54 shrink-0 flex-col border-r workspace-rail p-1.75 rail-motion",
    "lg:sticky lg:top-2 lg:z-30 lg:-mt-[var(--header-h)] lg:mr-2 lg:ml-2 lg:h-[calc(100dvh-1rem)] lg:w-[calc(13.5rem-0.75rem)] lg:rounded-[var(--radius-panel)] lg:border",
    collapsed && "w-16 px-2 lg:w-[calc(4rem-0.75rem)]",
  );
}
